import { List, Map as ImmutableMap } from 'immutable';
import Adapter from './Adapter';
import DSFieldRecord from 'customer-data-filters-ui/filterQueryFormat/DSFieldRecord/DSFieldRecord';
import HttpAdapterConfig from '../adapterConfigs/HttpAdapterConfig';
import PropertyOptionRecord from 'customer-data-objects/property/PropertyOptionRecord';
import { PAGE_VIEW_EVENT_PROPERTY } from 'customer-data-filters-ui/filterQueryFormat/DSAssetFamilies/DSAssetFamilies';
import enviro from 'enviro';
import PortalIdParser from 'PortalIdParser';
const e_visited_page_prod = '4-96000';
const e_visited_page_qa = '4-1079';
const parseOptions = options => {
  if (!options) {
    return List();
  }
  return options.reduce((acc, option) => {
    if (!option.hidden) {
      return acc.push(PropertyOptionRecord({
        label: option.label,
        value: option.value
      }));
    }
    return acc;
  }, List());
};
export class WebVisitorEventPropertiesAdapterConfig extends HttpAdapterConfig {
  constructor(...args) {
    super(...args);
    this.performanceTrackingKey = 'WebVisitorEventPropertiesAdapter';
  }
  get eventTypeId() {
    return enviro.isProd() ? e_visited_page_prod : e_visited_page_qa;
  }
  getCacheKey() {
    return `EVENT_PROPERTIES_${this.eventTypeId}`;
  }
  isAssetFamilySupported(assetFamily) {
    return assetFamily === PAGE_VIEW_EVENT_PROPERTY;
  }
  fetchData(httpClient) {
    const groupsOptions = {
      query: {
        portalId: PortalIdParser.get(),
        includeFieldLevelPermission: true,
        includeProperties: true
      },
      timeout: 60000
    };
    return httpClient(`properties/v4/groups/${this.eventTypeId}`, groupsOptions);
  }
  formatData(response) {
    if (!(response !== null && response !== void 0 && response.results) || !Array.isArray(response.results)) {
      return ImmutableMap();
    }

    // Extract all properties from all groups with their metadata
    const allProperties = [];
    response.results.forEach(group => {
      (group.properties || []).forEach(property => {
        allProperties.push({
          property,
          groupMetadata: {
            groupName: group.name,
            displayName: group.displayName,
            displayOrder: group.displayOrder
          }
        });
      });
    });
    return allProperties.reduce((acc, {
      property,
      groupMetadata
    }) => {
      const {
        label,
        name,
        description,
        fieldType,
        options,
        type,
        externalOptions,
        externalOptionsReferenceType
      } = property;
      const recordProperties = Object.assign({
        label,
        type,
        name,
        description,
        fieldType,
        options: parseOptions(options || [])
      }, externalOptions && {
        externalOptions
      }, externalOptionsReferenceType && {
        externalOptionsReferenceType
      }, {
        contextType: 'UnifiedEvent',
        context: this.eventTypeId,
        groupName: groupMetadata.groupName,
        groupDisplayName: groupMetadata.displayName,
        groupDisplayOrder: groupMetadata.displayOrder
      });
      return acc.set(name, DSFieldRecord(recordProperties));
    }, ImmutableMap());
  }
}
export default Adapter.makeFromConfig(WebVisitorEventPropertiesAdapterConfig);